<script setup lang="ts">
import CheckboxFive from '@/components/Forms/Checkboxes/CheckboxFive.vue'
import IcAnimateSpin from '@/components/Icons/IcAnimateSpin.vue'
import IcDownload from '@/components/Icons/IcDownload.vue'
import AlarmReportSearchBar from './AlarmReportSearchBar.vue'
import { printscreen } from '@/utils/screen/printscreen'

import { useAlarmStore } from '@/store/alarm'
import { onMounted, provide, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const isLoading = ref(false)
const { setLastSearchAlarmsType } = useAlarmStore()
const selectedCheckbox = ref('all')

const shareAlarmReport = () => {
  isLoading.value = true

  printscreen({
    name: 'alarm-report.png',
    querySelector: '#alarm-report-view-container',
  }).finally(() => {
    isLoading.value = false
  })
}

watch(selectedCheckbox, (newValue) => {
  if (newValue === 'classified') {
    setLastSearchAlarmsType(newValue)
  } else if (newValue === 'all') {
    setLastSearchAlarmsType(newValue)
  }
})

onMounted(() => {
  setLastSearchAlarmsType('all')
})

provide('selectedCheckbox', selectedCheckbox)
</script>

<template>
  <div class="flex flex-col px-2 lg:px-8">
    <div class="mb-4 flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div class="mb-4 flex max-w-lg flex-col sm:mb-0 sm:mr-4 sm:max-w-none">
        <div class="flex items-center gap-8 text-center">
          <h1 class="pb-1 text-left text-title-md2 font-semibold text-black">
            {{ t('alarm_report.header.title') }}
          </h1>
          <div class="flex flex-wrap items-center gap-4">
            <CheckboxFive labelText="Todos" value="all" v-model="selectedCheckbox" />
            <CheckboxFive labelText="Classificados" value="classified" v-model="selectedCheckbox" />
          </div>
        </div>

        <p class="max-w-prose text-left font-medium">
          {{ t('alarm_report.header.subtitle') }}
        </p>
      </div>

      <div class="hidden items-center justify-center pt-6 xl:flex">
        <button
          @click.prevent="shareAlarmReport"
          class="min-w-45 flex items-center justify-center gap-2 bg-green-dark px-4 py-3 text-white hover:bg-emerald-600">
          <IcDownload v-if="!isLoading" class="h-5 w-5 text-white" />
          <span v-else class="animate-spin">
            <IcAnimateSpin class="h-5 w-5 text-white" />
          </span>
          <span> {{ t('alarm_report.header.buttons.share') }} </span>
        </button>
      </div>
    </div>

    <AlarmReportSearchBar />
  </div>
</template>
